import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class DependedFieldModel extends BaseModel {
  uuid = '';
  key = '';
  dynamic_fields = {};

  static TRANSLATABLE_FIELDS = ['name'];

  rules = {
  };

  attributeLabels = {
    key: i18n.t('Key'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

}


